<template>
  <mdb-container fluid v-bind:style="{fontFamily: 'OpenSans-Regular', fontSize: '12px'}">
    <!--Section: Intro-->
    <mdb-row>
      <mdb-col>
        <h2 class="mt-lg-4 mb-1 pb-1" style="font-family: OpenSans-bold;">
          <strong>Trabajadores de obra</strong>
        </h2>
      </mdb-col>
      <mdb-col>
        <div class="mt-lg-4 mb-1 pb-1">
          <mdb-form-inline >
            <input
              v-on:keydown.enter.prevent="''"
              class="mr-sm-2 filter-input"
              type="text"
              v-model="search"
              style="width: 100% !important; border: 0px !important;"
              placeholder="Buscar por trabajador u obra"
            />
          </mdb-form-inline>
        </div>
      </mdb-col>
    </mdb-row>
    <!--Section: Main panel-->
    <section class="my-5">
      <!--Card-->
      <mdb-card cascade>
        <!--Section: Table-->
        <!--Top Table UI-->
        <div class="card card-cascade narrower z-depth-0">
          <!--Card image-->
          <div
            class="view view-cascade narrower py-2 mx-4 mb-3 d-flex justify-content-between align-items-center"
            style="margin-top: -2.25rem; background-color: #67a3cf; position: static;"
          >
            <div v-show="!requestShow" class="text-left">
              <mdb-tooltip material trigger="hover" :options="{placement: 'top'}">
                <span slot="tip">Alta trabajadores</span>
                <a slot="reference" href="/createWorker">
                  <img
                    alt="boton alta"
                    class="mt-0"
                    :src="imgServer+'apps/myfrac/admin/assets/Crear_BTN@3x.png'"
                    style="margin-left: 1rem; width: 31.2px; height: 31.2px; object-fit: contain;"
                  />
                </a>
              </mdb-tooltip>

              <mdb-input
                type="checkbox"
                class="form-check-input filled-in"
                id="selectAll"
                label="Seleccionar todo"
                v-model="selectAll"
                :style="{display: 'inline-block', marginTop: '2%', marginLeft: '0px' }"
                @click="select_all"
              />
            </div>

            <span
              v-show="!requestShow"
              class="white-text"
              style="font-family: OpenSans-Bold; font-size: 16px; margin-left: 10%;"
            >Trabajadores registrados</span>
            <span
              v-show="requestShow"
              class="white-text"
              style="font-family: OpenSans-Bold; font-size: 16px; margin-left: 40%; margin-top: 0.5rem; margin-bottom: 0.5rem;"
            >{{nameConstruction}}</span>

            <div
              v-show="requestShow"
              class="text-right"
              style=" margin-top: -10px; display: flex; float: right;margin-left: auto; "
            >
              <mdb-tooltip material trigger="hover" :options="{placement: 'top'}">
                <span slot="tip">Volver a solicitudes</span>
                <mdb-btn
                  slot="reference"
                  outline="white"
                  rounded
                  size="sm"
                  class="px-2 button_background"
                  @click="remove"
                >
                  <mdb-icon icon="angle-double-left" class="mt-0" />
                </mdb-btn>
              </mdb-tooltip>
              <mdb-tooltip material trigger="hover" :options="{placement: 'top'}">
                <span slot="tip">Ver datos del trabajador</span>
                <mdb-btn
                  slot="reference"
                  outline="white"
                  rounded
                  size="sm"
                  class="px-2 button_background"
                  @click="clickCard"
                >
                  <mdb-icon icon="eye" class="mt-0" />
                </mdb-btn>
              </mdb-tooltip>
            </div>

            <div v-show="!requestShow" class="text-right">
              <mdb-tooltip v-show="isAdmin" material trigger="hover" :options="{placement: 'top'}">
                <span slot="tip">Descargar credenciales</span>
                <mdb-btn
                  slot="reference"
                  outline="white"
                  rounded
                  size="sm"
                  class="px-2 button_background"
                  @click="downloadMultipleId"
                >
                  <mdb-icon icon="download" class="mt-0" />
                </mdb-btn>
              </mdb-tooltip>
              <mdb-tooltip v-show="isAdmin" material trigger="hover" :options="{placement: 'top'}">
                <span slot="tip">Generar credencial</span>
                <mdb-btn
                  slot="reference"
                  outline="white"
                  rounded
                  size="sm"
                  class="px-2 button_background"
                  @click="makeIdCard"
                >
                  <mdb-icon far icon="address-card" />
                </mdb-btn>
              </mdb-tooltip>
              <mdb-tooltip material trigger="hover" :options="{placement: 'top'}">
                <span slot="tip">Editar trabajador</span>
                <mdb-btn
                  slot="reference"
                  outline="white"
                  rounded
                  size="sm"
                  class="px-2 button_background"
                  @click="editWorker"
                >
                  <mdb-icon icon="pencil-alt" class="mt-0" />
                </mdb-btn>
              </mdb-tooltip>
              <mdb-tooltip material trigger="hover" :options="{placement: 'top'}">
                <span slot="tip">Eliminar trabajador</span>
                <mdb-btn
                  slot="reference"
                  outline="white"
                  rounded
                  size="sm"
                  class="px-2 button_background"
                  @click="removeWorker"
                >
                  <mdb-icon icon="trash" class="mt-0" />
                </mdb-btn>
              </mdb-tooltip>
            </div>
          </div>
          <!--/Card image-->
          <mdb-container>
            <div class="offset">
              <div class="listWorkerClass">
                <ul id="listWorkers" :style="{columnCount: perColumns}">
                  <li
                    v-for="(item, index) in displayedPost"
                    v-bind:key="index"
                    style="margin: 1rem; list-style:none;"
                  >
                    <mdb-card
                      class="Rectngulo-1685"
                      :style="borderCardStatus(item.status)"
                      testimonial
                    >
                      <mdb-avatar
                        class="mx-auto white"
                        style="width: 5rem !important; margin-bottom: -2rem;"
                      >
                        <img alt="foto del trabajador" :src="item.photo.publicUrl" class="rounded-circle img-fluid" />
                      </mdb-avatar>
                      <mdb-card-body>
                        <div
                          class="form-check checkbox-warning-filled"
                          style="margin-left: -2rem; top: 1rem; position: absolute;"
                        >
                          <input
                            type="checkbox"
                            class="form-check-input filled-in"
                            v-model="selected"
                            :value="item.id"
                            :id="'card'+item.id"
                            :data-uuid="item.uuid"
                            :data-status="item.status"
                          />
                          <label class="form-check-label" :for="'card'+item.id"></label>
                        </div>
                        <div class="body-div">
                          <span class="font-weight-bold">{{item.firstName+' '+item.lastName}}</span>

                          <p>
                            <span style="font-family: OpenSans-Bold">No. de obra:</span>
                            {{item.construction.number}}
                          </p>

                          <div v-if="item.status=='Rechazado'" class="tooltip-p">
                            {{item.status}}
                            <span
                              class="badge badge-pill badge-danger"
                              style="position: absolute; margin-top: -10px;"
                            >
                              <i class="fas fa-exclamation-circle"></i>
                            </span>
                            <span
                              class="tooltiptext"
                              style="width: 200px !important"
                            >{{item.rejectReason}}</span>
                          </div>
                        </div>
                      </mdb-card-body>
                    </mdb-card>
                  </li>
                </ul>
              </div>

              <nav aria-label="Page navigation example">
                <ul class="pagination pg-blue justify-content-center">
                  <li class="page-item">
                    <a
                      v-if="page != 1"
                      class="page-link Trazado-295"
                      @click="page--"
                      tabindex="-1"
                    >&laquo;</a>
                  </li>
                  <li class="page-item" v-for="pageNumber in pages.slice(page-1, page+5)" :key="pageNumber">
                    <a class="page-link Trazado-295" @click="page = pageNumber">{{pageNumber}}</a>
                  </li>
                  <li class="page-item">
                    <a
                      v-if="page < pages.length"
                      @click="page++"
                      class="page-link Trazado-295"
                    >&raquo;</a>
                  </li>
                </ul>
              </nav>
            </div>
          </mdb-container>
          <mdb-row>
            <div v-show="false" class="mb-2" style="margin-left: 56rem">
              <button
                type="button"
                class="btn btn-verde"
                style="padding: 5px 5px; font-size: 12px; width: 140px; height: 37px; margin-top: 1rem; margin-right: 2rem;"
              >Agregar a obra</button>
            </div>
            <div
              v-show="requestShow"
              class="mb-2"
              style=" display: flex; position: relative; float: right;margin-left: auto;"
            >
              <mdb-col md="4">
                <button
                  type="button"
                  class="waves-effect waves-dark btn btn-verde btn-color-prev"
                  @click="rejectWorker"
                >Rechazar</button>
              </mdb-col>
              <mdb-col md="4" style="margin-left: 1rem;">
                <mdb-btn
                  type="button"
                  class="waves-effect waves-dark btn btn-verde"
                  @click="approveWorker"
                >Aprobar</mdb-btn>
              </mdb-col>
            </div>
          </mdb-row>
        </div>

        <!--Section: Table-->
      </mdb-card>
      <!--/.Card-->
    </section>
    <!--Section: Main panel-->

    <mdb-modal class="modal-card" :show="showCard" @close="showCard = false">
      <mdb-modal-header class="text-center modal-header-style">
        <mdb-modal-title tag="span" class style="color: #ffffff;">Generar credencial</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
        <mdb-col>
          <mdb-row>
            <mdb-col sm="6">
              <mdb-card class="Rectngulo-1718" testimonial>
                <img
                  alt="foto trabajador"
                  :src="formCard.urlProfile"
                  class="rounded mx-auto d-block avatar-container"
                  style="margin-top: 2rem;"
                />
                <mdb-card-body>
                  <mdb-card-title
                    style="  text-align: center; font-family: OpenSans-Bold; font-size: 14px;"
                  >
                    <span>{{formCard.firstName}}&nbsp;</span>
                    <span>{{ formCard.lastName}}</span>
                    <p>Trabajador de obra</p>
                  </mdb-card-title>
                  <span style="text-align: center; font-family: OpenSans-Bold; font-size: 14px;">
                    {{formCard.contractor}}
                    <p>Responsable de la obra</p>
                  </span>
                </mdb-card-body>
              </mdb-card>
            </mdb-col>
            <mdb-col sm="6">
              <mdb-card class="Rectngulo-1718-back" testimonial>
                <mdb-card-body>
                  <div
                    style=" font-family: OpenSans-Bold; font-size: 14px; text-align: center; margin-bottom: 4rem;"
                  >
                    <span>
                      Número de la obra
                      <p>{{formCard.NConstruction}}</p>
                    </span>
                    <span>
                      Dirección de la obra
                      <p>{{formCard.Address}}</p>
                    </span>
                    <span>
                      {{formCard.company}}
                      <p>Constructora</p>
                    </span>
                  </div>
                  <span
                    style="color: #ffffff; text-transform: uppercase; font-size: 11px;"
                  >{{formCard.fracc}}</span>
                </mdb-card-body>
              </mdb-card>
            </mdb-col>
          </mdb-row>
          <mdb-row>
            <div
              class="text-right mb-1"
              style="display: flex; position: relative; float: right; margin-left: auto;"
            >
              <mdb-btn
                color="color-prev"
                class="btn-prev Rectngulo-14"
                @click="showCard = false"
              >Cancelar</mdb-btn>
              <mdb-btn
                class="btn btn-next btn-color-next Rectngulo-14"
                @click="generarSingleId()"
              >Descargar</mdb-btn>
            </div>
          </mdb-row>
        </mdb-col>
      </mdb-modal-body>
    </mdb-modal>

    <mdb-modal :show="showModal" @close="showModal = false">
      <mdb-modal-header class="text-center modal-header-style">
        <mdb-modal-title tag="span" class style="color: #ffffff;">Rechazar trabajador</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body class="mx-3">
        <mdb-col>
          <mdb-row>
            <div class="form-group">
              <label for="labelText">Ingresa el motivo del rechazo</label>
              <textarea
                class="form-control"
                id="labelText"
                rows="5"
                style="width: 270%"
                v-model="reject"
              ></textarea>
            </div>
          </mdb-row>
          <mdb-row>
            <div
              class="text-right mb-1"
              style="display: flex; position: relative; float: right; margin-left: auto;"
            >
              <mdb-btn
                color="color-prev"
                class="btn-prev Rectngulo-14"
                @click="showModal = false"
              >Cancelar</mdb-btn>
              <mdb-btn class="btn btn-next btn-color-next Rectngulo-14" @click="sendReject">Enviar</mdb-btn>
            </div>
          </mdb-row>
        </mdb-col>
      </mdb-modal-body>
    </mdb-modal>

    <mdb-modal class="modal-edit" :show="showDoc" @close="showDoc = false">
      <mdb-modal-header class="text-center modal-header-style">
        <mdb-modal-title tag="span" class style="color: #ffffff;">Información del trabajador</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body class="mx-3">
        <mdb-col>
          <mdb-row>
            <mdb-col col="5">
              <mdb-avatar class="mx-auto white">
                <img alt="foto trabajador" :src="avatarUrl" class="rounded-circle img-fluid" />
              </mdb-avatar>
            </mdb-col>
            <mdb-col col="7">
              <p>
                <span style="font-family: OpenSans-Bold; font-size: 15px;">
                  Nombre:
                  <span
                    style="font-family: OpenSans-Regular; font-size: 14px;"
                  >{{worker.firstName}}</span>
                </span>
              </p>
              <p>
                <span style="font-family: OpenSans-Bold; font-size: 15px;">
                  Apellidos:
                  <span
                    style="font-family: OpenSans-Regular; font-size: 14px;"
                  >{{worker.lastName}}</span>
                </span>
              </p>
              <p>
                <span style="font-family: OpenSans-Bold; font-size: 15px;">
                  Estatus:
                  <span
                    style="font-family: OpenSans-Regular; font-size: 15px;"
                  >{{worker.status}}</span>
                </span>
              </p>
              <p v-if="worker.status =='Rechazado'">
                <span style="font-family: OpenSans-Bold; font-size: 15px;">
                  Razon del rechazo:
                  <span
                    style="font-family: OpenSans-Regular; font-size: 15px;"
                  >{{worker.rejectReason}}</span>
                </span>
              </p>
              <div></div>
            </mdb-col>
          </mdb-row>
          <mdb-row>
            <mdb-col col="6">
              <div>Identificación oficial</div>
              <p>
                <iframe title="identificacion oficial" class="embed-responsive-item" :src="idUrl" allowfullscreen></iframe>
              </p>
            </mdb-col>
            <mdb-col col="6">
              <div>Comprobante de domicilio</div>
              <p>
                <iframe title="comprobante de domicilio" class="embed-responsive-item" :src="proofUrl" allowfullscreen></iframe>
              </p>
            </mdb-col>
          </mdb-row>
          <mdb-row>
            <div class="text-right mb-1">
              <mdb-btn
                color="color-prev"
                class="btn-prev Rectngulo-14"
                @click="showDoc = false"
              >Cerrar</mdb-btn>
            </div>
          </mdb-row>
        </mdb-col>
      </mdb-modal-body>
    </mdb-modal>
  </mdb-container>
</template>

<script>
/* eslint-disable */
import Swal from "sweetalert2";
import Axios from "axios";
import Servers from "../../../server.js";
import * as firebase from 'firebase/app'
import 'firebase/database'
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbCard,
  mdbCardImage,
  mdbCardHeader,
  mdbCardBody,
  mdbCardTitle,
  mdbCardText,
  mdbCardFooter,
  mdbCardUp,
  mdbCardAvatar,
  mdbCardGroup,
  mdbSelect,
  mdbBtn,
  mdbDatePicker,
  mdbTooltip,
  mdbSimpleChart,
  mdbIcon,
  mdbFormInline,
  mdbBadge,
  mdbView,
  mdbLineChart,
  mdbListGroup,
  mdbListGroupItem,
  mdbInput,
  mdbDatatable,
  mdbAvatar,
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter
} from "mdbvue";

export default {
  name: "Workers",
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardImage,
    mdbCardHeader,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbCardUp,
    mdbCardAvatar,
    mdbCardGroup,
    mdbSelect,
    mdbBtn,
    mdbDatePicker,
    mdbTooltip,
    mdbSimpleChart,
    mdbIcon,
    mdbFormInline,
    mdbBadge,
    mdbView,
    mdbLineChart,
    mdbListGroup,
    mdbListGroupItem,
    mdbInput,
    mdbDatatable,
    mdbAvatar,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter
  },
  data() {
    return {
      formCard: {
        urlProfile: "",
        firstName: "",
        lastName: "",
        contractor: "",
        company: "",
        NAccion: 0,
        NConstruction: 0,
        Address: "",
        EndDate: "",
        fracc: ""
      },
      urlServer: Servers.serverApi,
      imgServer: Servers.serverImg,
      isAdmin: false,
      workersList: [],
      workerSelected: [],
      worker: [],
      page: 1,
      perPage: 10,
      perColumns: 5,
      pages: [],
      numberOfPages: 0,
      requestShow: false,
      showModal: false,
      showCard: false,
      reject: "",
      showDoc: false,
      nameConstruction: "",
      avatarUrl: Servers.serverImg + "apps/myfrac/admin/assets/btncapturar.png",
      idUrl: Servers.serverImg + "apps/myfrac/admin/assets/btncapturar.png",
      proofUrl: Servers.serverImg + "apps/myfrac/admin/assets/btncapturar.png",
      search: null,
      selectAll: false,
      selected: [],
      workersFirebase:[],
      uuidConstruction: ""
    };
  },
  methods: {
    borderCardStatus(status){
      

      if(status === 'Aprobado'){
        return {borderBottom: '15px solid #4dbf7a'}
      }
      else if(status === 'Rechazado'){
        return {borderBottom: '15px solid #ed5f5f'}
      }
      else{
        return {borderBottom: '15px solid #ffbb33'}

      }

    },
    select_all() {
      this.selected = [];
      if (!this.selectAll) {
        for (let i in this.workersList) {
          this.selected.push(this.workersList[i].id);
        }
      }
    },
    downloadMultipleId() {
      this.makeListOfWorkers();
      if (this.workerSelected.length > 0) {
        var type = "application/zip";
        var downloadName = "credenciales.zip";
        var ContentType = "multipart/form-data";
        var uuidArray = "";
        if (this.workerSelected.length === 1) {
          var work = this.workerSelected[0];
          let found = this.workersList.find(
            element => element.uuid === work.uuid
          );
          downloadName = found.firstName + " " + found.lastName + ".zip";
        }

        this.workerSelected.map(function(value, key) {
          uuidArray = uuidArray + "uuid=" + value.uuid + "&";
        });
        uuidArray = uuidArray.slice(0, -1);

        let aux = this;
        Swal.fire({
          title: "<span style='font-size: 20px;'>Descargando ...</span>",
          width: "30%",
          allowOutsideClick: false,
          onBeforeOpen: () => {
            Swal.showLoading();
          }
        });
        Axios.get(
          aux.urlServer + "api/constructionWorkers/workerLicense?" + uuidArray,
          {
            responseType: "arraybuffer",
            headers: {
              Authorization: "Bearer " + localStorage.getItem("access_token"),
              "Content-Type": ContentType
            }
          }
        )
          .then(response => {
            let blob = new Blob([response.data], { type: type });
            const downloadUrl = URL.createObjectURL(blob);
            let a = document.createElement("a");
            a.href = downloadUrl;
            a.download = downloadName;
            document.body.appendChild(a);
            a.click();
            Swal.hideLoading("");
            Swal.fire({
              title:
                "<span style='font-size: 20px;'>Descarga completada</span>",
              width: "20%",
              allowOutsideClick: false,
              showConfirmButton: true
            });
           
          })
          .catch(error => {
            console.log(error.response.data);
            this.showMessageError("Ha ocurrido un error",error.response.data);
          });
      } else {
        this.showMessageInfo(
          "Para realizar esta acción, asegúrate de seleccionar por lo menos un trabajador."
        );
      }
    },
    generarSingleId() {
      this.showModal = false;
      var downloadName =
        this.worker.firstName + " " + this.worker.lastName + ".zip";
      var type = "application/zip";
      var ContentType = "multipart/form-data";
      let aux = this;
      Swal.fire({
        title: "<span style='font-size: 20px;'>Descargando ...</span>",
        width: "30%",
        allowOutsideClick: false,
        onBeforeOpen: () => {
          Swal.showLoading();
        }
      });
      Axios.get(
        aux.urlServer +
          "api/constructionWorkers/workerLicense?uuid=" +
          aux.worker.uuid,
        {
          responseType: "arraybuffer",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": ContentType
          }
        }
      )
        .then(response => {
          let blob = new Blob([response.data], { type: type });
          const downloadUrl = URL.createObjectURL(blob);
          let a = document.createElement("a");
          a.href = downloadUrl;
          a.download = downloadName;
          document.body.appendChild(a);
          a.click();
          Swal.hideLoading("");
          Swal.fire({
            title: "<span style='font-size: 20px;'>Descarga completada</span>",
            width: "20%",
            allowOutsideClick: false,
            showConfirmButton: true
          });
        })
        .catch(error => {
          console.log(error.data);
          aux.showMessageError("Ha ocurrido un error", error.response);
        });
    },
    makeIdCard() {
      this.makeListOfWorkers();
      if (this.workerSelected.length == 1) {
        this.worker = null;
        this.showCard = true;
        var work = this.workerSelected[0];
        let found = this.workersList.find(
          element => element.uuid === work.uuid
        );
        this.worker = found;
        if (this.worker.status != "Aprobado") {
          this.showMessageInfo(
            "Solo es posible visualizar credenciales de trabajadores aprobados."
          );
          return 0;
        }

        this.formCard.urlProfile = this.worker.photo.publicUrl;
        this.formCard.firstName = this.worker.firstName;
        this.formCard.lastName = this.worker.lastName;
        this.formCard.contractor =
          this.worker.construction.contractor.firstName +
          " " +
          this.worker.construction.contractor.lastName;
        (this.formCard.company = this.worker.construction.contractor.enterprise),
          (this.formCard.NAccion = 0);
        this.formCard.NConstruction = this.worker.construction.number;
        this.formCard.Address = this.worker.construction.street.name;
        this.formCard.EndDate = this.worker.construction.endDate;
        this.formCard.fracc = this.worker.construction.street.testZone.testFrac.name;
      } else if (this.workerSelected.length == 0) {
        this.showMessageInfo(
          "Es necesario seleccionar un trabajador para ver su información."
        );
      } else {
        this.showMessageInfo(
          "No se puede ver la información de más de un trabajador a la vez."
        );
      }
    },
    clickCard() {
      this.makeListOfWorkers();
      if (this.workerSelected.length == 1) {
        this.showDoc = true;
        var work = this.workerSelected[0];
        let found = this.workersList.find(
          element => element.uuid === work.uuid
        );
        this.worker = found;
        this.avatarUrl = this.worker.photo.publicUrl;
        this.idUrl = this.worker.identification.publicUrl;
        this.proofUrl = this.worker.proofOfAddress.publicUrl;
        //console.log(this.worker);
      } else if (this.workerSelected.length == 0) {
        this.showMessageInfo(
          "Es necesario seleccionar un trabajador para ver su informacion."
        );
      } else {
        this.showMessageInfo(
          "No se puede ver la información de más de un trabajador a la vez."
        );
      }
    },
    remove() {
      window.location.href = "/workersRequest";
    },
    approveWorker() {
      let aux = this;
      aux.makeListOfWorkers();
      if (this.workerSelected.length == 1) {
        var worker = this.workerSelected[0];
        if (worker.status == "Aprobado") {
          aux.showMessageInfo(
            "Solamente puedes aprobar solicitudes pendientes."
          );
        } else {
          var data = {};
          Swal.fire({
            title: "<span style='font-size: 20px;'>Cargando...</span>",
            width: "30%",
            allowOutsideClick: false,
            onBeforeOpen: () => {
              Swal.showLoading();
            }
          });

          Axios.put(
            Servers.serverApi +
              "api/constructionWorkers/" +
              worker.uuid +
              "/approve",
            data,
            {
              responseType: "application/json",
              headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token")
              }
            }
          ).then(
            function(response) {
              
              let found = aux.workersFirebase.find(element => element.worker === worker.firstName+' '+worker.lastName);
              // var auxMe = JSON.parse(localStorage.getItem('me'));
              // firebase.database().ref('workers/'+auxMe.idFrac+'/'+aux.uuidConstruction+'/'+found.key).remove();


              Swal.fire({
                title:
                  "<span style='font-size: 20px;'>¡Solicitud Aprobada!</span>",
                type: "success",
                width: "30%",
                showConfirmButton: true,
                showCloseButton: true,
                confirmButtonText: "Aceptar",
                customClass: {
                  confirmButton: "btn-modal-accept"
                },
                onBeforeOpen: () => {
                  Swal.hideLoading();
                },
                onClose: () => {
                  window.location.reload();
                }
              });
            },
            function(error) {
              aux.showMessageError(
                "Solicitud no completada",
                error.response.data
              );
            }
          );
        }
      } else if (aux.workerSelected.length == 0) {
        aux.showMessageInfo(
          "Es necesario seleccionar un trabajador para poder aceptar."
        );
      } else {
        aux.showMessageInfo(
          "No se puede dar aprobar a más de un trabajador a la vez."
        );
      }
    },
    rejectWorker() {
      let aux = this;
      aux.makeListOfWorkers();
      if (this.workerSelected.length == 1) {
        var worker = this.workerSelected[0];
        if (worker.status == "Aprobado") {
          aux.showMessageInfo(
            "Solo se pueden rechazar solicitudes pendientes."
          );
        } else if (worker.status == "Rechazado") {
          aux.showMessageInfo("El trabajador ya ha sido rechazado");
        } else {
          this.showModal = true;
        }
      } else if (aux.workerSelected.length == 0) {
        aux.showMessageInfo(
          "Es necesario seleccionar un trabajador para poder rechazar."
        );
      } else {
        aux.showMessageInfo(
          "No se puede dar rechazar a más de un trabajador a la vez."
        );
      }
    },
    sendReject() {
      let aux = this;
      var worker = aux.workerSelected[0];
      Swal.fire({
        title: "<span style='font-size: 20px;'>Cargando...</span>",
        width: "30%",
        allowOutsideClick: false,
        onBeforeOpen: () => {
          Swal.showLoading();
        }
      });

      Axios.put(
        Servers.serverApi +
          "/api/constructionWorkers/" +
          worker.uuid +
          "/reject",
        aux.reject,
        {
          responseType: "application/json",
          headers: {
            "Content-Type": "text/plain",
            Authorization: "Bearer " + localStorage.getItem("access_token")
          }
        }
      )
        .then(function(response) {

          let found = aux.workersFirebase.find(element => element.worker === worker.firstName+' '+worker.lastName);
              // var auxMe = JSON.parse(localStorage.getItem('me'));
              //firebase.database().ref('workers/'+auxMe.idFrac+'/'+aux.uuidConstruction+'/'+found.key).remove();

          Swal.fire({
            title:
              "<span style='font-size: 20px;'>¡Solicitud rechazada!</span>",
            type: "success",
            width: "30%",
            showConfirmButton: true,
            confirmButtonText: "Aceptar",
            customClass: {
              confirmButton: "btn-modal-accept"
            },
            onBeforeOpen: () => {
              aux.showModal = false;
              Swal.hideLoading();
            },
            onClose: () => {
              window.location.reload();
            }
          });
        })
        .catch(error => {
          aux.showMessageError("Solicitud no completada", error.response.data);
        });
    },
    removeWorker() {
      let aux = this;
      aux.makeListOfWorkers();
      if (aux.workerSelected.length == 1) {
        aux.workerSelected.map(function(value, key) {
          Swal.fire({
            title:
              "<span style='font-size: 16px; font-family: OpenSans-Regular;'>¿Seguro que deseas eliminar éste trabajador?</span>",
            html:
              "<span style='font-size: 12px'>El trabajador se eliminará permanentemente y sus accesos quedarán inhabilitados</span>",
            imageUrl:
              Servers.serverImg + "apps/myfrac/admin/assets/Delete_Icon.png",
            imageWidth: "22%",
            imageHeight: "auto",
            width: "30%",
            showCancelButton: true,
            confirmButtonText: "Eliminar",
            cancelButtonText: "Cancelar",
            reverseButtons: true,
            customClass: {
              confirmButton: "btn-modal-accept",
              cancelButton: "btn-modal-cancel"
            }
          }).then(result => {
            if (result.value) {
              Axios.delete(
                aux.urlServer +
                  "api/constructionWorkers/" +
                  value.uuid +
                  "/administrator",
                {
                  responseType: "application/json",
                  headers: {
                    Authorization:
                      "Bearer " + localStorage.getItem("access_token")
                  }
                }
              ).then(
                function(response) {
                  aux.showMessageSucces("Trabajador eliminado correctamente");
                  //window.location.reload();
                },
                function(error) {
                  aux.showMessageError(
                    "Ha ocurrido un error",
                    error.response.data
                  );
                  return false;
                }
              );
            }
          });
        });
      } else if (aux.workerSelected.length == 0) {
        aux.showMessageInfo(
          "Es necesario seleccionar un trabajador para poder darlo de baja."
        );
      } else {
        aux.showMessageInfo(
          "No se puede dar de baja a más de un trabajador a la vez."
        );
      }
    },
    makeListOfWorkers() {
      let aux = this;
      aux.workerSelected = [];
      var arr = Array.prototype.slice.call(
        document.getElementsByClassName("form-check-input")
      );
      aux.selected.map(function(value, key) {
        let found = aux.workersList.find(element => element.id === value);
        aux.workerSelected.push(found);

        /*if (value.checked) {
          aux.workerSelected.push({
            uuid: value.dataset.uuid,
            status: value.dataset.status
          });
        }*/
      });
    },
    editWorker() {
      let aux = this;
      aux.makeListOfWorkers();
      if (this.workerSelected.length == 1) {
        this.workerSelected.map(function(value, key) {
          if(value.status != "Aprobado"){
          window.location.href = "./createWorker?token=" + value.uuid;
          }
          else{
            aux.showMessageInfo(
          "Solo se puedan editar trabajadores que no han sido aprobados."
        );

          }
        });
      } else if (aux.workerSelected.length == 0) {
        aux.showMessageInfo(
          "Es necesario seleccionar un trabajador para poder editar."
        );
      } else {
        aux.showMessageInfo(
          "No se puede editar a más de un trabajador a la vez."
        );
      }
    },
    setPages() {
      this.pages=[];
      for (let index = 1; index <= this.numberOfPages; index++) {
        this.pages.push(index);
      }
    },
    paginate(wList) {
      let aux = this;
      aux.numberOfPages = Math.ceil(wList.length / aux.perPage);
      let page = this.page;
      let perPage = this.perPage;
      let from = page * perPage - perPage;
      let to = page * perPage;
      this.setPages()
      return wList.slice(from, to);
    },
    getWorkers() {
      let aux = this;
      Axios.get(Servers.serverApi + "api/constructionWorkers/frac", {
        responseType: "application/json",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
      })
        .then(function(response) {
          aux.workersList = response.data;
          aux.numberOfPages = Math.ceil(aux.workersList.length / aux.perPage);
        })
        .catch(error => {
          aux.showMessageError("Ha ocurrido un error", error.response.data);
        });
    },
    getWorkersByContractor(uuid) {
      let aux = this;
      Axios.get(
        Servers.serverApi +
          "api/constructionWorkers/contractor?contractor=" +
          uuid,
        {
          responseType: "application/json",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token")
          }
        }
      )
        .then(function(response) {
          aux.workersList = response.data;
          aux.numberOfPages = Math.ceil(aux.workersList.length / aux.perPage);
        })
        .catch(error => {
          aux.showMessageError("Ha ocurrido un error", error.response.data);
        });
    },

    getWorkersByConstruction(uuid) {
      let aux = this;
      //from fireBase
      aux.workersFirebase=[];
      aux.uuidConstruction = uuid;
    
      // var starCountRef = firebase.database().ref('workers/'+me.idFrac+'/'+uuid+'/');
      // starCountRef.on('value', function(snapshot){
      //   var objeto = snapshot.val()
      //   for(var propiedad in objeto){
      //     aux.workersFirebase.push({
      //       key:propiedad,
      //       worker: objeto[propiedad].worker
      //     })
      //   }
      // });

      //from API
      Axios.get(
        Servers.serverApi +
          "api/constructionWorkers/construction?construction=" +
          uuid,
        {
          responseType: "application/json",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token")
          }
        }
      )
        .then(function(response) {
          aux.workersList = response.data;
          aux.nameConstruction = response.data[0].construction.name;
          aux.numberOfPages = Math.ceil(aux.workersList.length / aux.perPage);
        })
        .catch(error => {
          aux.showMessageError("Ha ocurrido un error", error.response.data);
        });
    },
    showMessageInfo: function(text) {
      Swal.fire({
        title: "<span style='font-size: 14px;'>" + text + "</span>",
        type: "info",
        width: "30%",
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "btn-modal-accept"
        }
      });
    },
    showMessageError: function(text, error) {
      let aux = this;
      let errorText;
      Swal.fire({
        title: "<span style='font-size: 20px'>" + text + "</span>",
        html: "<span style='font-size: 12px'>" + error + "</span>",
        imageUrl:
          Servers.serverImg + "apps/myfrac/admin/assets/Cancel_icon.png",
        imageWidth: "22%",
        imageHeight: "auto",
        width: "30%",
        //confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "btn-modal-accept"
        },
        onBeforeOpen: () => {
          Swal.hideLoading();
        },
        onClose: () => {}
      });
    },
    showMessageSucces: function(text) {
      Swal.fire({
        title: "<span style='font-size: 20px;'>¡Eliminación exitosa!</span>",
        html: "<span style='font-size: 12px;'>" + text + "</span>",
        type: "success",
        width: "30%",
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "btn-modal-accept"
        },
        onClose: () => {
          window.location.reload();
        }
      });
    }
  },
  mounted() {},
  created() {
    if (localStorage.getItem("role") != "Contratista") {
      this.isAdmin = true;
    } else {
      this.isAdmin = false;
    }

    if (this.$route.query.construction != undefined) {
      this.getWorkersByConstruction(this.$route.query.construction);
      if (localStorage.getItem("role") != "Contratista") {
        this.requestShow = true;
      }
      //Administrador
      //SOLICITUDES DE TRABAJADORES POR OBRA
    } else {
      if (localStorage.getItem("role") == "Contratista") {
        var uuid = localStorage.getItem("uuid");
        //Contratista
        //TRABAJADORES POR CONTRATISTA
        this.getWorkersByContractor(uuid);
      } else {
        //Administrador
        //TRABAJADORES POR FRACCIONAMIENTO
        this.getWorkers();
      }
    }
  },
  watch: {
    workersList() {
      this.setPages();
    }
  },
  computed: {
    displayedPost() {
      if (this.search) {
      this.page=1
        return this.paginate(
          this.workersList.filter(item => {
            var nameComplete = item.firstName + " " + item.lastName;
            return (
              item.firstName.toLowerCase().indexOf(this.search.toLowerCase()) >=
                0 ||
              item.lastName.toLowerCase().indexOf(this.search.toLowerCase()) >=
                0 ||
              item.construction.name.toLowerCase().indexOf(this.search.toLowerCase()) >=
                0 ||
              nameComplete.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
            );
          })
        );
      } else return this.paginate(this.workersList);
    }
  }
};
</script>

<style scoped>
::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #fff;
  opacity: 1; /* Firefox */
}

:-ms-input-placeholder { /* Internet Explorer 10-11 */
  color: #fff;
}

::-ms-input-placeholder { /* Microsoft Edge */
  color: #fff;
}
.filter-input {
  position: initial;
  margin-left: 0.5em;
  margin-right: 1rem;
  margin-top: 2rem;
  border-radius: 25px;
  height: 35px;
  padding-left: 35px;
  padding-top: 8px;
  padding-bottom: 8px;
  padding-right: 10px;
  font-family: "OpenSans-Regular";
  font-size: 12px;
  color: #fff;
  background: url("../../../static/zoom_in.png") no-repeat scroll 12px 7px
    #67a3cf;
  background-size: 20px 20px;
}

.filter-input:focus {
  font-family: "OpenSans-Regular";
  font-size: 12px;
  color: #fff;
  background: url("../../../static/zoom_in.png") no-repeat scroll 12px 7px
    #67a3cf;
  background-size: 20px 20px;
}

.modal-header-style {
  height: 51.5px;
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.08);
  background-color: #67a3cf;
}

.Rectngulo-14 {
  width: 83.5px !important;
  height: 27.5px !important;
  font-size: 10px;
}


</style>

<style>
.pagination > .active > a,
.pagination > .active > span {
  z-index: 3;
  color: #999;
  cursor: default;
  background-color: #67a3cf !important;
  border-color: #707070 !important;
}
.paginate_button {
  background: #f6f6f6 !important;
}

.tooltip-p {
  position: relative;
  display: inline-block;
}

/* Tooltip text */
.tooltip-p .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: #555;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;

  /* Position the tooltip text */
  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 50%;
  margin-left: -60px;

  /* Fade in tooltip */
  opacity: 0;
  transition: opacity 0.3s;
}

/* Tooltip arrow */
.tooltip-p .tooltiptext::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #555 transparent transparent transparent;
}

/* Show the tooltip text when you mouse over the tooltip container */
.tooltip-p:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}

.testimonial-card .avatar {
  margin-top: 10px !important;
  width: 90px !important;
  border: 0px !important;
}

.Rectngulo-1685 {
  width: 150.7px;
  height: 170px;
  border-radius: 6px !important;
  background-color: #67a3cf !important;
  color: #ffffff;
}

.filled-in:checked + label::after{
  border-color: #000000 !important;
  background-color: #000000 !important;

}

.checkbox-warning-filled
  [type="checkbox"][class*="filled-in"]:checked
  + label:after {
  border-color: #000000 !important;
  background-color: #000000 !important;
}

.Trazado-295 {
  width: auto;
  height: 35px;
  border: solid 1px #e8e9ec !important;
  background-color: #ffffff !important;
}

.btn-modal-accept {
  height: 50% !important;
  width: auto !important;
  background-color: #3085d6 !important;
  font-size: 12px !important;
}

.modal-edit .modal-content {
  width: 150% !important;
  margin-left: -8rem !important;
}



.modal-card .modal-content {
  width: 120% !important;
}

.Rectngulo-1718 {
  width: 232.9px;
  height: 370.3px;
  background-image: url(https://d39vj9j1h6phln.cloudfront.net/apps/myfrac/admin/assets/card_front.png) !important;
}

.Rectngulo-1718 .avatar {
  margin-top: 6rem !important;
}

.Rectngulo-1718-back {
  width: 232.9px;
  height: 370.3px;
  background-image: url(https://d39vj9j1h6phln.cloudfront.net/apps/myfrac/admin/assets/card_back.png) !important;
}

.Rectngulo-1718-back .card-body {
  margin-top: 5rem !important;
}
.avatar-container {
  width: 159px;
  height: 162px;
}


.body-div {
  position: absolute;
  margin-top: 20px;
  margin-left: 10px;
}

.listWorkerClass > ul {
  columns: 5;
  padding: 16px 0;
  list-style: none;
}

.listWorkerClass > ul > li {
  display: inline-block;
  width: 100%;
  border-top: 1px;
}
</style>